import KeyedAndNamedDto from 'modules/base/dto/KeyedAndNamedDto';

export class FmFileEditDto extends KeyedAndNamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.file = null;
		/** @type {number} */
		this.parentDirectory = null;
		/** @type {number} */
		this.parentStorage = null;
		/** @type {string} */
		this.fileName = null;
		/** @type {string} */
		this.copyright = null;
	}

	/**
	 * @typedef {Object} _FmFileEditDtoProps
	 * @property {string} file
	 * @property {number} parentDirectory
	 * @property {string} parentStorage
	 * @property {string} fileName
	 * @property {string} copyright
	 * @typedef {import("../KeyedAndNamedDto").KeyedAndNamedDtoProps & _FmFileEditDtoProps} FmFileEditDtoProps
	 */
	/**
	 *
	 * @param {FmFileEditDtoProps} props
	 * @returns {FmFileEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.file = props.file;
		this.parentDirectory = props.parentDirectory;
		this.parentStorage = props.parentStorage;
		this.fileName = props.fileName;
		this.copyright = props.copyright;
		return this;
	}
}

export default FmFileEditDto;
